import { FC, useContext, useEffect, useState } from "react";
import {
  Typography,
  Box,
  useMediaQuery,
  Button,
  CircularProgress,
} from "@material-ui/core";
import { useTheme } from "@material-ui/core";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import { Answer, QuestionDetail } from "../../store/Learn2/learn.interface";
import Loader from "../../helpers/Loader";
import PoolContext from "../../store/Pool/PoolContext";
import LearnQuizTimer, { isQuizExpired } from "./LearnQuizTimer";
import { useLearnContext } from "../../store/Learn2/LearnContext";
import { useHistory } from "react-router";

interface LearnQCMProps {
  title: string;
  question: QuestionDetail;
  submitAnswer: (answerId: string) => void;
}
interface LearnQuizQuesitonProps extends Omit<LearnQCMProps, 'title'> {}

const LearnQCM: FC<LearnQCMProps> = (props) => {
  const theme = useTheme();
  const isActive = useMediaQuery(theme.breakpoints.down("sm"));

  const { title, question, submitAnswer } = props;
  
  const { getActivePool } = useContext<any>(PoolContext);
  const pool = getActivePool();
 
  if (!question) {
    return (
      <Loader />
    )
  }

  return (
    <>
        <Box mt={isActive ? 3 : 5} ml={isActive ? 0 : 0}>
          <Box mb={2} p={0} mt={2}>
            <Typography variant="h2" color="secondary">
              Learn about{" "}
              <Typography component="span" variant="h2" color="primary">
                {pool?.name}
              </Typography>
              {" "} to get whitelisted
            </Typography>{" "}
            {/** typegrapic box */}
          </Box>
          <Typography variant="body1" className="body-color text-br">
            You will need at least{" "}
            <Typography
              component="span"
              color="primary"
              className="fw-bold"
            >
              7/10{" "}
            </Typography>{" "}
            for each quiz. If you fail more than 3 times you cannot be
            whitelisted.{" "}
            <Typography
              component="span"
              color="primary"
              className="fw-bold"
            >
              <LearnQuizTimer />
            </Typography>{" "}
          </Typography>
          <Box 
            mt={ isActive ? 2 : 3 } 
            mb={ isActive ? 2 : 0 } 
            display="flex"
          >
            <Typography variant="h3" color="secondary">
              { title?.toUpperCase() }
            </Typography>
          </Box>
          <LearnQuizQuesiton  
            question={question} 
            submitAnswer = {submitAnswer}
            />
        </Box>
    </>
  )
};

const LearnQuizQuesiton  = (props: LearnQuizQuesitonProps) => {
  const history = useHistory();
  const theme = useTheme();
  const {quizIndex, quizStatus, quizStartTime, quizzes} = useLearnContext();
  const isActive = useMediaQuery(theme.breakpoints.down("sm"));

  const quiz = quizzes?.[quizIndex]

  const { question, submitAnswer } = props;
  
  const [selectedAnswer, setSelectedAnswer] = useState<string | null>();
  const [showProgress, toggleProgress] = useState<boolean>(false);

  useEffect(() => {
    setSelectedAnswer(null);
    if (showProgress) toggleProgress(false);
  }, [question])

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedAnswer(event.target.value);
  }

  const handleSubmission = () => {
    if (!selectedAnswer) return;
    toggleProgress(true);
    submitAnswer(selectedAnswer);
  }

  if (!question) {
    return (
      <Loader />
    )
  }

  return (
    <Box
      p={3}
      mt={2}
      className="box-border-main"
      mr={isActive ? 0 : 20}
    >
      <Typography variant="h4" color="secondary">
        { question?.question }
      </Typography>

      <Box mt={1}>
        <FormControl component="fieldset">
          <RadioGroup
            aria-label="gender"
            name="gender1"
            value={selectedAnswer}
            onChange={handleChange}
          >
            {
              question?.answers.map((answer: Answer, index: number) => (
                <FormControlLabel
                  value={answer.id}
                  control={<Radio />}
                  label={answer.answer}
                  color="secondary"
                  key={index}
                />
              ))
            }
          </RadioGroup>
        </FormControl>
      </Box>

      <Box mt={isActive ? 4 : 5} mb={isActive ? 3 : 10}>
        <Button
          variant="contained"
          color="secondary"
          className="continue-button"
          disabled={!selectedAnswer}
          onClick={() =>
            handleSubmission()
          }
        >
          Continue &nbsp;
          {
            showProgress
            ? <CircularProgress
                className="m-class"
                variant="indeterminate"
                size={10}
                thickness={2}
                color="secondary"
              />
            : " "
          }
        </Button>
      </Box>
    </Box>
  )
};

export default LearnQCM;
